import n from "./ghl-ui.es364.js";
import o from "./ghl-ui.es365.js";
function m(e, t) {
  return e && e.length ? o(e, n(t)) : [];
}
export {
  m as default
};
